<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <!-- Forgot Password v1 -->
    <div class="card mb-0">
      <div class="card-header justify-content-center bg-secondary">
        <a href="#" target="_self" class="brand-logo mb-0 mt-0">
          <img src="{{ coreConfig.app.logo.light }}" alt="brand-logo" height="50"/>
        </a>
      </div>
      <div class="card-body pt-2">

        <h4 class="card-title mb-1">Hai dimenticato la password?</h4>
        <p class="card-text mb-2">Inserisci il tuo username. Ti invieremo una mail con una nuova password.</p>

        <form class="auth-forgot-password-form mt-2" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="forgot-password-username" class="form-label">Username</label>
            <input
              type="text"
              class="form-control"
              placeholder=""
              formControlName="username"
              id="forgot-password-username"
              aria-describedby="forgot-password-username"
              tabindex="1"
              autofocus
              [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
            />
            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
              <div *ngIf="f.username.errors.required">L'username è obbligatorio</div>
              <div *ngIf="f.username.errors.username">Inserisci un utente valido</div>
            </div>
          </div>
          <button class="btn btn-secondary btn-block" tabindex="2" rippleEffect>Invia la mail</button>
        </form>

        <p class="text-center mt-2">
          <a routerLink="/" class="text-secondary">
            <i data-feather="chevron-left" class="mb-25"></i> Torna al login
          </a>
        </p>
      </div>
    </div>
    <!-- /Forgot Password v1 -->
  </div>
</div>
